import { SVGAttributes, CSSProperties, Key } from 'react';
import { tuple } from '../_utils';

export const SizeTypes = tuple('auto');
export type SizeType = typeof SizeTypes[number];

export interface IconCommonProps {
  size?: SizeType | Key;
  color?: string;
  style?: CSSProperties;
  className?: string;
}

export interface IconBaseProps extends SVGAttributes<SVGSVGElement>, IconCommonProps {}

export interface IconProps extends IconBaseProps {
  name: string;
}
